module.exports = __webpack_public_path__ + "img/finland-liver-cancer-female.f8967504.png";